import { brandCaptionLowerThird } from "./brand-caption-lower-third";
import { brandCaptionLowerThirdDataUrl } from "./brand-caption-lower-third-data-url";
import { brandCaptionLowerThirdEntityId } from "./brand-caption-lower-third-entity-id";
import { brandCaptionLowerThirdIsDefault } from "./brand-caption-lower-third-is-default";
import { brandCaptionLowerThirdIsInUse } from "./brand-caption-lower-third-is-in-use";
import { brandEntityId } from "./brand-entity-id";

export const brandCaptionLowerThirdEntityRaw = {
  type: "object",
  required: ["id", "brandId", "dataUrl", "caption", "isDefault", "isInUse"],
  properties: {
    id: brandCaptionLowerThirdEntityId,
    brandId: brandEntityId,
    dataUrl: brandCaptionLowerThirdDataUrl,
    caption: brandCaptionLowerThird,
    isDefault: brandCaptionLowerThirdIsDefault,
    isInUse: brandCaptionLowerThirdIsInUse
  },
  additionalProperties: false
};
